import { render, staticRenderFns } from "./RevisionSolicitudReclamacionVer.vue?vue&type=template&id=4d5f84e6"
import script from "./RevisionSolicitudReclamacionVer.vue?vue&type=script&lang=js"
export * from "./RevisionSolicitudReclamacionVer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports